module.exports = __webpack_public_path__ + "static/media/tokyo1.efb2d529.jpg";